import {VIBRATE_TIME} from '../../../ClickerGame.constants';
import {DI_TOKENS} from '@/di/di.tokens';
import {FederatedPointerEvent} from 'pixi.js';

import {injected} from 'brandi';

import {BaseComponent, IGameWorld} from '@specials/gcs-engine';

import {Vibration} from '@/utils/Vibration';

import {ClickerGameEventNames, ClickerGameEvents} from '../../../ClickerGameEvents';
import {HeartsEmitterComponent} from '../../../components/HeartsEmitterComponent/HeartsEmitterComponent';
import {ResultsSpaceshipAnimationManagerComponent} from './ResultsSpaceshipAnimationManagerComponent';
import {SpaceshipViewComponent} from './SpaceshipViewComponent';

export class ResultsSpaceshipInteractivityComponent extends BaseComponent {
  private viewComponent?: SpaceshipViewComponent;
  private animationManagerComponent?: ResultsSpaceshipAnimationManagerComponent;
  private emitterComponent?: HeartsEmitterComponent;

  constructor(private readonly vibration: Vibration, private readonly clickerEvents: ClickerGameEvents) {
    super();
  }

  public destroy(): void {
    this.viewComponent?.view.off('pointerdown', this.handleClick);
  }

  public onAddToWorld(world: IGameWorld): void {
    super.onAddToWorld(world);

    this.viewComponent = this.gameObject.getComponent(SpaceshipViewComponent);
    this.animationManagerComponent = this.gameObject.getComponent(ResultsSpaceshipAnimationManagerComponent);
    this.emitterComponent = this.gameObject.getComponent(HeartsEmitterComponent);

    const view = this.viewComponent?.view;
    if (!view) return;

    view.cursor = 'pointer';
    view.eventMode = 'static';

    view.on('pointerdown', this.handleClick);
  }

  private handleClick = (e: FederatedPointerEvent): void => {
    this.animationManagerComponent?.playClickAnimation();
    this.animationManagerComponent?.playSoundClickByState();

    this.emitterComponent?.emitHeart(e.screen);

    this.vibration.vibrate(VIBRATE_TIME);

    this.clickerEvents.emitEvent(ClickerGameEventNames.Tap);
  };
}

injected(ResultsSpaceshipInteractivityComponent, DI_TOKENS.vibration, DI_TOKENS.clickerGameEvents);
